var HeaderData = require("./headerData.js");
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var LineData = require('../../../svg/lineData.js');
var EllipseData = require('../../../svg/ellipseData.js');
var RectangleData = require('../../../svg/rectangleData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');
var PthComponentAttribute = require('./pthComponentAttribute.js');

var HeaderRightAngleData = function(position, angle, init) {
    HeaderData.apply(this, arguments);

    this.horizontalTerminalTailLength = this.value("horizontalTerminalTailLength", true);
    this.verticalTerminalTailLength = this.value("verticalTerminalTailLength", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.horizontalTerminalTailLength);
    this.nonTransformedSegmentedGeometry.addTrigger(this.verticalTerminalTailLength);
};

lib_core.inherit(HeaderRightAngleData, HeaderData);
lib_core.JsonParser.registerClass(HeaderRightAngleData, "HeaderRightAngleData");
module.exports = HeaderRightAngleData;

HeaderRightAngleData.prototype.setupMinMaxPtrMap = function() {
    HeaderData.prototype.setupMinMaxPtrMap.call(this);
    this.validationMap["horizontalTerminalTailLength"] = [this.horizontalTerminalTailLength];
    this.validationMap["verticalTerminalTailLength"] = [this.verticalTerminalTailLength];
};

HeaderRightAngleData.prototype.getTranslationVectorForBody = function(pads) {
    var footprintPadsBBox = this.getFootprintPadsBBox(pads);
    var footprintPadsCentroidLocation = new lib_geometry.Coord(footprintPadsBBox.x + footprintPadsBBox.width / 2, footprintPadsBBox.y + footprintPadsBBox.height / 2);
    
    var moveVectorX = footprintPadsCentroidLocation.x;
    var moveVectorY = footprintPadsCentroidLocation.y - (this.verticalPadCount() - 1) * this.verticalPinPitch() / 2;
    
    var moveVector = new lib_geometry.Coord(moveVectorX, moveVectorY);
    return moveVector;
};

HeaderRightAngleData.prototype.getTerminalOutlines = function(body) {
    var outlines = [];
    var nCols = this.horizontalPadCount();
    var firstTerminalOffsetFromBodyEdge;

    if(nCols > 1) {
        firstTerminalOffsetFromBodyEdge = (body.height - (nCols - 1) * this.horizontalPinPitch()) / 2;
    } else {
        firstTerminalOffsetFromBodyEdge = body.height / 2;
    }

    for(var i = 0; i < nCols; i++) {
        var x1, x2;
        x1 = x2 = -body.height / 2 + firstTerminalOffsetFromBodyEdge + i * this.horizontalPinPitch();
        var y1 = -IPCRules.silkscreenStrokeWidth / 2; //terminal outline always starts from body max
        var y2 = y1 - this.terminalPostLength();

        var line = new LineData(x1, y1, x2, y2, IPCRules.silkscreenStrokeWidth);
        outlines.push(line);
    }

    return outlines;
};

//First create the body outline centered around the origin then shift according to the translation vector calculated from pads bbox
HeaderRightAngleData.prototype.getBodyOutline = function(pads, body) {
    //adjust the body width in case body outline edge is placed with minimum clearence from pads
    if(this.horizontalTerminalTailLength() < pads[0].getTopCopper().width() / 2 + IPCRules.silkscreenClearance) {
        body.width = body.width - (pads[0].getTopCopper().width() / 2 + IPCRules.silkscreenClearance - this.horizontalTerminalTailLength());
    }
    
    var outline = new RectangleData(new lib_geometry.Coord(0, 0), 0, body.height, body.width, false, IPCRules.assemblyOutlineStrokeWidth);
    
    //place body outline maintaining minimum clearence from pads
    var translationY = -Math.max(this.horizontalTerminalTailLength(), pads[0].getTopCopper().width() / 2 + IPCRules.silkscreenClearance) - body.width / 2;
    outline.move(this.getTranslationVectorForBody(pads).add(new lib_geometry.Coord(0, translationY)));

    return outline;
};

HeaderRightAngleData.prototype.getAssemblyOutline = function(pads) {
    if (pads.length === 0) return;

    var body = this.getBodyForAssembly();
    return this.getBodyOutline(pads, body);
};

//dot location depends on the location of first pad
HeaderRightAngleData.prototype.getPinOneMarker = function(firstPad) {
    var pinMarkerPosX, pinMarkerPosY = firstPad.pos().y;
    var totalDotMarkerClearence = IPCRules.silkscreenPinMarkerDotClearance + IPCRules.dotPinMarkerSize / 2;
    var pinOneOriginPositionId = PthComponentAttribute.type.HEADER.pinNumberSequencePattern[this.pinNumberSequencePattern()].pinOnePositionId;

    //draw dot marker beside pad 1 maintaining clearance from pad if pad is outside the body
    //draw dot marker beside pad 1 maintaining clearance from body if pad is inside the body
    switch(pinOneOriginPositionId) {
        case this.pinOneOriginLocation.TOP_LEFT:
        case this.pinOneOriginLocation.BOTTOM_LEFT:
            pinMarkerPosX = firstPad.pos().x - firstPad.getTopCopper().width() / 2 - totalDotMarkerClearence;
        break;

        case this.pinOneOriginLocation.TOP_RIGHT:
        case this.pinOneOriginLocation.BOTTOM_RIGHT:
            pinMarkerPosX = firstPad.pos().x + firstPad.getTopCopper().width() / 2 + totalDotMarkerClearence;
        break;
    }
    
    return new EllipseData(new lib_geometry.Coord(pinMarkerPosX, pinMarkerPosY), 0, IPCRules.dotPinMarkerSize, IPCRules.dotPinMarkerSize, true, 0);
};

HeaderRightAngleData.prototype.getSilkscreen = function(pads) {
    if(pads.length === 0) return [];

    var self = this;
    var silkscreen = [];
    
    ////////////////////
    //   Pin Marker   //
    ////////////////////
    silkscreen.push(this.getPinOneMarker(pads[0]));

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////
    
    /*
        Draw component silkscreen around body. For this package pads are located outside the body
     */
    var body = this.getBodyForSilkscreen();
    silkscreen.push(this.getBodyOutline(pads, body));

    /*
        Draw silkscreen lines for horizontal portion of terminals
     */
    var moveVector = this.getTranslationVectorForBody(pads).add(new lib_geometry.Coord(0, -this.horizontalTerminalTailLength()));
    this.getTerminalOutlines(body).forEach(function(lines) {
        lines.move(moveVector.add(new lib_geometry.Coord(0, -self.bodyWidthMax())));
        silkscreen.push(lines);
    });

    return silkscreen;
};